import { purchaseTrackingManagerMachine } from '@artblocks/sdk/dist/machines/purchase-tracking-manager-machine'
import { createActorContext } from '@xstate/react'

export const purchaseTrackingManagerMachineContext = createActorContext(purchaseTrackingManagerMachine)
